module.exports = __webpack_public_path__ + "img/placeholder.bed7fe8f.gif";